// source以下の最大のunitの倍数を得る
export const getMaxLTMultiple = (source, unit) => Math.floor(source / unit) * unit;

// source以上の最小のunitの倍数を得る
export const getMinGTMultiple = (source, unit) => Math.ceil(source / unit) * unit;



// WEBPACK FOOTER //
// ./es6/admin-common-js/apps/csv_chart/charts/portfolio/analysis/utils/integerUtility.js